/**
 * admin ControllersPage `lastDate` 와 동일:
 * 해당 controllerId 를 가진 device.updatedAt 중 최댓값.
 * API lastDate(CTRL_INFO)가 있으면 zone 데이터와 함께 최신값을 취한다.
 *
 * @param {string} controllerId
 * @param {Array} zones home/getZones
 * @param {string|Date|undefined} apiLastDate CTRL_INFO 등 API가 준 lastDate
 * @returns {Date|undefined}
 */
export function resolveControllerLastDate(controllerId, zones, apiLastDate) {
  let maxMs = null;

  if (apiLastDate) {
    const t = new Date(apiLastDate).getTime();
    if (!Number.isNaN(t)) maxMs = t;
  }

  if (controllerId && Array.isArray(zones)) {
    for (const zone of zones) {
      for (const group of zone.groups || []) {
        for (const device of group.devices || []) {
          if (device.controllerId !== controllerId || !device.updatedAt) continue;
          const ms = new Date(device.updatedAt).getTime();
          if (Number.isNaN(ms)) continue;
          if (maxMs == null || ms > maxMs) maxMs = ms;
        }
      }
    }
  }

  return maxMs != null ? new Date(maxMs) : undefined;
}
